<template>
  <button
      class="group w-9 h-9 rounded flex justify-center items-center bg-primary-400 hover:bg-primary-100 focus:bg-purple_semantic active:bg-purple_semantic disabled:bg-grays-400">
		<span class="material-symbols-rounded text-primary-700 group-disabled:text-grays-600">
			<slot></slot>
		</span>
  </button>
</template>

<script>
export default {
  name: "button-icon"
}
</script>

<style>

</style>